/**
 * useContaDoEditor — o que os componentes de imagem do editor precisam saber da conta logada:
 *   - `donoId`: a foto do dono mora em `{dono}/media/{id}/` na CDN (miniatura no editor e no preview);
 *   - `nomeDoRamo`: título dos exemplos na biblioteca ("Exemplos de Barbearia").
 * O ramo é o mesmo `theme_id` que a Api manda para a Mídia filtrar os exemplos (MediaController, decisão M33).
 */
import { useMemo } from 'react';
import { authService } from '../../services/authService';
import { useThemeCustom } from '../../hooks/useThemeCustom';

export default function useContaDoEditor() {
  const { themeId, availableThemes } = useThemeCustom();
  const donoId = authService.getUserInfo()?.userId ?? null;
  const nomeDoRamo = useMemo(
    () => (availableThemes ?? []).find((t) => t.id === themeId)?.name ?? null,
    [availableThemes, themeId],
  );
  return { donoId, nomeDoRamo };
}
